import { useStorage } from '@vueuse/core'
import { computed, ref } from 'vue'
import { useI18n, useLocalePath } from '#imports'
import { useUserStore } from '~/store/user'
import { isEmailValidate, isPasswordValidate, isPhoneValidate } from '@/utils/regular.js'
import { guideGoogle, registerEmailCheck, registerEmailConfirm, registerMobileCheck, registerMobileConfirm, registerSendEmailCode, registerSendMobileCode, resetPw1, resetPw2, resetPw3, sendEmailCode, sendSmsCode, singInCheck, singInConfirm, slideRisk } from '~/apis/base'
import { defaultLang } from '@/utils/locale'
import { getDialingCodeByLocale, getTopDomainByUrl } from '~/utils/tools'
import cookie from 'js-cookie'

export const form = ref({
  agree: false,
  countryCode: getDialingCodeByLocale(),
  email: '',
  mobile: '',
  password: '',
})
export const formRef = ref()
export const loading = ref(false)
export const type = ref('2')
export const sliderConfig = ref({})
export const showVerificationCode = ref(false) // 展示验证码
export const sendToken = ref('')
export const bindGAShow = ref(false)
export const loginCodeData = ref({})
export const currentActive = ref(null) // 1,邮箱， 2,手机， 3谷歌验证码
export const forgotInfo = ref() // 找回密码信息
export const step = ref(1) // 找回密码步骤
export const showForgotSuccess = ref(false)
export const sendCodeStatus = ref({
  sms: {
    status: 0,
    count: 59,
    isSend: false,
    timer: null,
  },
  email: {
    status: 0,
    count: 59,
    isSend: false,
    timer: null,
  },
})

export function resetForm() {
  form.value = Object.create(null)
  formRef.value.restoreValidation()
}

export function goHome() {
  const user = useUserStore()
  if (user.isLogin) {
    const lang = useStorage('lang', defaultLang)
    window.location.href = `/${lang.value}/`
  }
}

export function useRules() {
  const { t } = useI18n()
  const rules = computed(() => {
    return {
      mobile: [{
        validator(rule, value) {
          if (!value) {
            return new Error(t('请输入手机号'))
          }
          else if (!isPhoneValidate(value)) {
            return new Error(t('请输入正确的手机号'))
          }
          return true
        },
        name: 'mobile',
        trigger: ['blur'],
      }],
      email: [{
        validator(rule, value) {
          if (!value) {
            return new Error(t('请输入邮箱'))
          }
          else if (!isEmailValidate(value.trim())) {
            return new Error(t('请输入正确的邮箱地址'))
          }
          return true
        },
        name: 'email',
        trigger: ['blur'],
      }],
      password: [{
        validator(rule, value) {
          if (!value) {
            return new Error(t('请输入密码'))
          }
          // else if (value.length < 8) {
          //   return new Error('至少8位字符')
          // }
          // else if (value.length > 20) {
          //   return new Error('最多20位字符')
          // }
          else if (!isPasswordValidate(value)) {
            return new Error(t('8-20位字符,且至少包含大写字母、小写字母、数字和特殊符合任意三种'))
          }
          return true
        },
        name: 'password',
        trigger: ['blur'],
      }],
      repeatPassword: [{
        validator(rule, value) {
          if (!value) {
            return new Error(t('请输入密码'))
          }
          else if (value !== form.value.password) {
            return new Error(t('两次密码不一致'))
          }
          return true
        },
        name: 'repeatPassword',
        trigger: ['blur'],
      }],
      // inviteCode: [{
      //   validator(rule, value) {
      //     if (value === '') {
      //       return true
      //     }
      //     else if (!isInviteValidate(value)) {
      //       return new Error(邀请码填写错误)
      //     }
      //     return true
      //   },
      //   trigger: ['blur'],
      // }],
    }
  })
  return rules
}

export function noSideSpace(v, type) {
  form.value[type] = v.replace(/(^\s*)|(\s*$)/g, '')
}
export function filterPhone(v, type) {
  form.value[type] = v.replace(/[^A-Z0-9]+/g, '')
}
export function useRegisterExtra() {
  const route = useRoute()
  const extra = {
    inviteCode: route.query.invitCode,
    channelCode: route.query.channelCode,
    agree: false,
    countryCode: getDialingCodeByLocale(),
  }

  const init = () => {
    form.value.email = ''
    form.value.mobile = ''
    form.value.password = ''
    form.value.repeatPassword = ''
    for (const k in extra) {
      const v = extra[k]
      if (v) {
        form.value[k] = v
      }
    }
  }
  return { extra, init }
}

export function registerConfirm() {
  formRef.value.validate(async (errors) => {
    if (!errors) {
      const loginName = type.value === '1' ? form.value.mobile : form.value.email
      loading.value = true
      const { success, data } = await slideRisk({ loginName, bizType: type.value })
      if (success) {
        if (data.asf === 0) {
          checkRegister()
        }
        else {
          sliderConfig.value = data
        }
        loading.value = false
      }
      else {
        loading.value = false
      }
    }
  })
}

export function resetSliderConfig() {
  sliderConfig.value = {}
  loading.value = false
}

export async function checkRegister(captchaObj) {
  const { geetest_seccode, geetest_validate, geetest_challenge: challenge } = captchaObj?.getValidate() || {}
  const { agree, countryCode, mobile, email, inviteCode, password } = form.value
  const parmams = {
    agree,
    inviteCode,
    challenge,
    password,
    geetest_seccode,
    geetest_validate,
    ...(type.value === '1' ? { mobile, countryCode } : { email }),
  }
  const checkUrl = type.value === '1' ? registerMobileCheck : registerEmailCheck
  const { success, data } = await checkUrl(parmams)
  if (success) {
    sendToken.value = data.sendToken
    sendCode('register', type.value === '1' ? 'sms' : 'email')
    resetSliderConfig()
    showVerificationCode.value = true
  }
  else {
    loading.value = false
  }
}

export async function sendCode(sendPage, sendType) {
  // 注册scene 1手机 2邮箱 登录scene 3手机 4邮箱 找回密码scene 11
  const { countryCode, mobile, email } = form.value
  const isEmail = type.value === '2'
  const params = isEmail ? { email } : { mobile, countryCode }
  const forgotParams = {}
  if (sendPage === 'forgot') {
    const { email, phone, countryCode } = forgotInfo.value
    if (sendType === 'sms') {
      forgotParams.mobile = phone
      forgotParams.countryCode = countryCode
    }
    else {
      forgotParams.email = email
    }
    forgotParams.scene = 11
    forgotParams.token = sendToken.value
  }
  else if (sendPage === 'login') {
    params.scene = isEmail ? 4 : 3
    params.token = sendToken.value
  }
  else {
    params.scene = isEmail ? 2 : 1
    params.sendToken = sendToken.value
  }
  let sendUrl = null
  if (sendPage === 'register') {
    sendUrl = isEmail ? registerSendEmailCode : registerSendMobileCode
  }
  else if (sendPage === 'forgot') {
    sendUrl = sendType === 'email' ? sendEmailCode : sendSmsCode
  }
  else {
    sendUrl = isEmail ? sendEmailCode : sendSmsCode
  }
  const { success } = await sendUrl(sendPage === 'forgot' ? forgotParams : params)
  if (success) {
    run(sendType)
    showVerificationCode.value = true
  }
}
export function run(type) {
  sendCodeStatus.value[type].isSend = true
  sendCodeStatus.value[type].status = 1
  sendCodeStatus.value[type].count = 59
  clearInterval(sendCodeStatus.value[type].timer)
  sendCodeStatus.value[type].timer = setInterval(() => {
    if (sendCodeStatus.value[type].count) {
      sendCodeStatus.value[type].count--
    }
    else {
      sendCodeStatus.value[type].status = 0
      sendCodeStatus.value[type].count = 59
    }
  }, 1000)
}

export async function register(verificationCode) {
  const { countryCode, mobile, email, inviteCode, password, channelCode } = form.value
  const parms = {
    password,
    repeatPassword: password,
    regType: type.value,
    verificationCode,
    inviteCode,
    channelCode,
    ...(type.value === '1' ? { mobile, countryCode } : { email }),

  }
  const registerConfirmUrl = type.value === '1' ? registerMobileConfirm : registerEmailConfirm
  const { success, data } = await registerConfirmUrl(parms)
  if (success) {
    setToken(data.token)
    showGoogleGuide()
  }
}

export function hideVerificationCode() {
  showVerificationCode.value = false
  clearInterval(sendCodeStatus.value.sms.timer)
  clearInterval(sendCodeStatus.value.email.timer)
  sendCodeStatus.value = {
    sms: {
      status: 0,
      count: 59,
      isSend: false,
      timer: null,
    },
    email: {
      status: 0,
      count: 59,
      isSend: false,
      timer: null,
    },
  }
  loading.value = false
  showForgotSuccess.value = false
  const { init } = useRegisterExtra()
  init()
  step.value = 1
}

export function loginConfirm() {
  formRef.value.validate(async (errors) => {
    if (!errors) {
      const loginName = type.value === '1' ? form.value.mobile : form.value.email
      loading.value = true

      await slideRisk({ loginName, bizType: type.value === '2' ? '4' : '3' }).then(({ success, data }) => {
        if (success) {
          sliderConfig.value = data
          if (data.asf === 0) {
            checkLogin()
          }
        }
        else {
          loading.value = false
        }
      }).catch(() => {
        loading.value = false
      })
    }
  })
}

export async function checkLogin(captchaObj) {
  const { countryCode, mobile, email, password } = form.value || {}

  const { geetest_seccode, geetest_validate, geetest_challenge: challenge } = captchaObj?.getValidate() || {}
  const params = {
    loginPwd: password,
    geetest_seccode,
    geetest_validate,
    challenge,
    ...(type.value === '1' ? { mobileNum: mobile, countryCode, scene: '3' } : { email, scene: '4' }),
  }
  loading.value = false
  const { success, data } = await singInCheck(params)

  if (success) {
    const { token, googleAuth } = data
    sendToken.value = token

    // 不需要输入验证码登录
    if (data?.secondaryVerificationStatus === '0') {
      setToken(token)
      showGoogleGuide()
    }
    // 需要输入验证码登录
    else {
      loginCodeData.value = {
        email: params.email,
        scene: params.scene,
        token,
        type,
        googleAuth,
      }
      // 登录没有ga验证直接发送验证码
      if (googleAuth !== '1') {
        currentActive.value = type.value === '2' ? '1' : '2'
        sendCode('login', type.value === '1' ? 'sms' : 'email')
      }
      else {
        currentActive.value = '3'
      }
      showVerificationCode.value = true
    }
  }
  else {
    resetSliderConfig()
  }
}

export async function loginConfirmation(code) {
  const { countryCode, mobile, email } = form.value
  const parms = {
    type: currentActive.value === '3' ? '2' : '1',
    token: sendToken.value,
    ...(type.value === '1' ? { mobileNum: mobile, countryCode, scene: '3' } : { email, scene: 4 }),
  }
  const keyList = {
    1: 'emailCode',
    2: 'smsCode',
    3: 'gaCode',
  }
  const codeKey = keyList[currentActive.value]
  parms[codeKey] = code
  const { success } = await singInConfirm(parms)
  if (success) {
    setToken(sendToken.value)
    showGoogleGuide()
  }
}

export async function setToken(token) {
  const user = useUserStore()
  localStorage.setItem('token', token)
  user.syncCookieToken()
  user.getUserInfo()
  cookie.set('partner-token', token, {
    domain: getTopDomainByUrl(),
    expires: 365,
  })
}

// ga弹窗判断
export async function showGoogleGuide() {
  showVerificationCode.value = false
  const { success, data } = await guideGoogle()
  if (success && data?.isNeed) {
    bindGAShow.value = true
  }
  else {
    const router = useRouter()
    const route = useRoute()
    const localePath = useLocalePath()
    const { backUrl, ...query } = route.query
    if (backUrl) {
      const queryString = new URLSearchParams(query).toString()
      window.location.href = `${decodeURIComponent(backUrl)}${queryString ? `?${queryString}` : ''}`
    }
    else {
      router.replace({
        path: localePath('/'),
      })
    }
  }
}

// 找回密码下一步
export async function forgotNext() {
  formRef.value.validate(async (errors) => {
    if (!errors) {
      const loginName = type.value === '1' ? form.value.mobile : form.value.email
      loading.value = true
      const { success, data } = await slideRisk({ loginName, bizType: 11 })
      if (success) {
        if (data.asf === 0) {
          checkForgot()
        }
        else {
          sliderConfig.value = data
        }
        loading.value = false
      }
      else {
        loading.value = false
      }
    }
  })
}

// 找回密码验证(第一步)
export async function checkForgot(captchaObj) {
  const { geetest_seccode, geetest_validate, geetest_challenge: challenge } = captchaObj?.getValidate() || {}
  const parms = {
    account: type.value === '1' ? form.value.mobile : form.value.email,
    challenge,
    geetest_seccode,
    geetest_validate,
    countryCode: form.value.countryCode,
    scene: 11,
  }
  const { success, data } = await resetPw1(parms)
  if (success) {
    forgotInfo.value = data
    sendToken.value = data.token
    if (data.verifyGa) {
      currentActive.value = '3'
    }
    else {
      currentActive.value = type.value === '2' ? '1' : '2'
      sendCode('forgot', type.value === '1' ? 'sms' : 'email')
    }
    showVerificationCode.value = true
  }
}

// 找回新密码code码验证
export async function checkForgotCode(code) {
  const parms = {
    type: currentActive.value === '3' ? 3 : type.value,
    scene: 11,
    token: forgotInfo.value.token,
    account: type.value === '1' ? form.value.mobile : form.value.email,
  }
  const keyList = {
    1: 'emailCode',
    2: 'smsCode',
    3: 'googleCode',
  }
  if (type.value === '1') {
    parms.countryCode = form.value.countryCode
  }
  const codeKey = keyList[currentActive.value]
  parms[codeKey] = code
  const { success } = await resetPw2(parms)
  if (success) {
    showVerificationCode.value = false
    step.value = 2
  }
}

// 找回
export async function forgotPassword() {
  formRef.value.validate(async (errors) => {
    if (!errors) {
      const { password, repeatPassword } = form.value
      const parms = {
        token: forgotInfo.value.token,
        newPassword: password,
        repeatPassword,
        scene: 11,
      }
      const { success } = await resetPw3(parms)
      loading.value = true
      if (success) {
        forgotInfo.value = {}
        loading.value = false
        showForgotSuccess.value = true
      }
      else {
        loading.value = false
      }
    }
  })
}

if (import.meta.client) {
  window.useUserStore = useUserStore
}
